import React from "react";

import './VideoTagSelect.scss'

const VideoTagSelect = ({ tagDetails, onRemove }) => {
  return (
    <span className='video-tag'>
      {tagDetails.tagName}
      <button
        type="button"
        className='cancelButton'
        onClick={onRemove}
        aria-label={`Remove ${tagDetails.tagName}`}
      >
        x
      </button>
    </span>
  );
};

export default VideoTagSelect;
